import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

export const ProgressBar = ({ 
    value, 
    hexColor = "#00a62b", 
    color = "primary", 
    label = "", 
    suffix = "%",
    displayValue
}) => (
    <Box sx={{ display: "flex", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column-reverse", sm: "row" } }}>
        <Box sx={{ width: "100%", mr: { xs: 0, sm: 1 }, mb: { xs: 0, sm: 0 }, mt: { xs: 0.5, sm: 0 } }}>
            <LinearProgress
                variant="determinate"
                value={Math.min(value, 100)}
                color={hexColor ? undefined : color}
                sx={{
                    height: 8,
                    borderRadius: 5,
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: hexColor || "inherit"
                    },
                    backgroundColor: hexColor ? `${hexColor}40` : "inherit",
                }}
            />
        </Box>
        <Box sx={{ minWidth: { xs: "auto", sm: 100 }, width: { xs: "100%", sm: "auto" }, textAlign: { xs: "left", sm: "right" } }}>
            <Typography 
                variant="body2" 
                color="text.secondary" 
                sx={{ 
                    fontWeight: 'bold', 
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }, 
                    lineHeight: 1.2,
                    display: '-webkit-box',
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    wordBreak: 'break-all'
                }}
            >
                {displayValue !== undefined ? `${displayValue}${suffix}` : `${Math.round(value)}${suffix}`}
            </Typography>
        </Box>
    </Box>
);
